<template>
  <div>
    <div class="title">
      <Breadcrumb>
        <BreadcrumbItem to="/ticketCenter/taskScheduler">{{ $t('task_scheduler.title') }}</BreadcrumbItem>
        <BreadcrumbItem>{{ detail.taskNumber || taskNumber }}</BreadcrumbItem>
      </Breadcrumb>
      <Button type="primary" style="float:right;margin-top:-25px;" @click="returnGo">{{ $t('task_scheduler.back') }}</Button>
    </div>

    <Row :gutter="10" style="margin-bottom: 10px;">
      <Col span="24">
        <Card>
          <p slot="title" style="line-height:16px;font-size:13px;color:#000;height: 15px;">{{ $t('task_scheduler.basicInfo') }}</p>
          <Form :label-width="120" label-position="left">
            <Row>
              <Col span="12">
                <FormItem :label="$t('task_scheduler.taskNumber')">{{ detail.taskNumber }}</FormItem>
              </Col>
              <Col span="12">
                <FormItem :label="$t('task_scheduler.taskName')">{{ detail.taskName }}</FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12">
                <FormItem :label="$t('task_scheduler.customer')">{{ detail.companyName || detail.companyId || '-' }}</FormItem>
              </Col>
              <Col span="12">
                <FormItem :label="$t('task_scheduler.account')">{{ detail.accountName || detail.accountId || '-' }}</FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12">
                <FormItem :label="$t('task_scheduler.taskStatus')">
                  <Tag :color="statusColor(detail.status)">{{ statusText(detail.status) }}</Tag>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem :label="$t('task_scheduler.plannedTime')">{{ detail.plannedExecutionTime || '-' }}</FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12">
                <FormItem :label="$t('task_scheduler.relatedTicket')">
                  <a v-if="detail.ticketNumber" style="color:#2d8cf0;" @click="toTicketDetail">{{ detail.ticketNumber }}</a>
                  <span v-else>-</span>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem :label="$t('task_scheduler.createdTime')">{{ detail.createdTime || '-' }}</FormItem>
              </Col>
            </Row>
            <Row v-if="detail.remark">
              <Col span="24">
                <FormItem :label="$t('task_scheduler.remark')">{{ detail.remark }}</FormItem>
              </Col>
            </Row>
          </Form>
        </Card>
      </Col>
    </Row>

    <!-- 动态 sections 渲染 -->
    <Row :gutter="10" style="margin-bottom: 10px;" v-for="(section, sIdx) in (detail.sections || [])" :key="sIdx">
      <Col span="24">
        <Card>
          <p slot="title" style="line-height:16px;font-size:13px;color:#000;height: 15px;">{{ section.title }}</p>
          <Table
            v-if="section.type === 'table'"
            :columns="buildColumns(section.columns)"
            :data="section.data || []"
            :no-data-text="$t('common.noData')"
            border>
          </Table>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
// 任务状态枚举
var STATUS_PENDING = 0;
var STATUS_EXECUTING = 1;
var STATUS_COMPLETED = 2;
var STATUS_FAILED = 3;
var STATUS_CANCELED = 4;

export default {
  name: 'TaskSchedulerDetail',
  data() {
    return {
      taskNumber: '',
      detail: {}
    };
  },
  computed: {
    statusOptions() {
      return [
        { value: STATUS_PENDING, label: this.$t('task_scheduler.pending') },
        { value: STATUS_EXECUTING, label: this.$t('task_scheduler.executing') },
        { value: STATUS_COMPLETED, label: this.$t('task_scheduler.completed') },
        { value: STATUS_FAILED, label: this.$t('task_scheduler.failed') },
        { value: STATUS_CANCELED, label: this.$t('task_scheduler.canceled') }
      ];
    }
  },
  mounted() {
    this.taskNumber = this.$route.query.taskNumber || this.$route.query.taskCode || this.$route.query.taskId;
    this.loadDetail();
  },
  methods: {
    loadDetail() {
      if (!this.taskNumber) return;
      this.$api.taskScheduler.getTaskDetail(this.taskNumber).then(res => {
        var d = (res.data && res.data.data) || res.data || {};
        this.detail = d || {};
      });
    },
    // 根据后端返回的 columns 定义构建 iView Table 的 columns
    buildColumns(columns) {
      if (!columns || !Array.isArray(columns)) return [];
      return columns.map(col => ({
        title: col.label,
        key: col.key,
        minWidth: 120,
        render: (h, { row }) => {
          var val = row[col.key];
          return h('span', val != null ? String(val) : '-');
        }
      }));
    },
    returnGo() {
      this.$router.push({ path: '/ticketCenter/taskScheduler' });
    },
    toTicketDetail() {
      this.$router.push({
        path: '/cases/caseDetail',
        query: { id: this.detail.ticketId }
      });
    },
    statusText(status) {
      var item = this.statusOptions.find(it => it.value === status);
      return item ? item.label : '-';
    },
    statusColor(status) {
      switch (status) {
        case STATUS_PENDING: return 'default';
        case STATUS_EXECUTING: return 'blue';
        case STATUS_COMPLETED: return 'green';
        case STATUS_FAILED: return 'red';
        case STATUS_CANCELED: return 'default';
        default: return 'default';
      }
    }
  }
};
</script>

<style scoped>
.title {
  width: 100%;
  box-sizing: border-box;
  padding: 15px 0px 8px 4px;
}
.ivu-breadcrumb {
  font-size: 13px;
  font-weight: 600;
  color: #515a6e;
}
.ivu-form-item {
  margin-bottom: 4px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/cases/task_scheduler/TaskSchedulerDetail.vue